import PropTypes from 'prop-types';

import { upperFirst } from 'lodash';
import { FileIcon, FileTextIcon, TicketIcon, WrenchIcon, GiftIcon, Grid2x2PlusIcon, CodeIcon } from 'lucide-react';

import AppSidebarSubitems, { AppSidebarSubitem } from '@/components/app-layout/SidebarSubitems';
import { useGlobalStore } from '@/stores/global';
import { useGlobalAuthStore } from '@/stores/global/auth';
import AppSidebar from '@Components/app-layout/Sidebar';
import AppSidebarItem from '@Components/app-layout/SidebarItem';

const propTypes = {
  types: PropTypes.array,
}

const ICONS = {
  'file-alt': FileTextIcon,
  'ticket-alt': TicketIcon,
  file: FileIcon,
}

export default function CMSSidebar({ types }) {
  const { auth: { isSuperAdmin } } = useGlobalAuthStore()
  if (!types) return null

  return <AppSidebar>
    {types.map(([type, { plural, icon }], idx) => <TypeSidebarSubitems
      key={idx}
      type={type}
      icon={ICONS[icon] || FileTextIcon}
      alias={upperFirst(plural)}
    />)}
    <AppSidebarItem to="/cms/builder-blocks" icon={Grid2x2PlusIcon} alias="Builder Blocks" />
    <AppSidebarItem to="/cms/rewards" icon={GiftIcon} alias="Rewards" />
    <AppSidebarItem to="/cms/snippets" icon={CodeIcon} alias="Snippets" />
    <AppSidebarSubitems icon={WrenchIcon} alias='Settings' to='/cms/settings/themes'>
      {isSuperAdmin && <AppSidebarSubitem to='/cms/settings/themes' alias='Themes' />}
      <AppSidebarSubitem to='/cms/settings/navigations' alias='Navigations' />
      <AppSidebarSubitem to='/cms/settings/rootfiles' alias='Root Files' />
      <AppSidebarSubitem to='/cms/settings/routes' alias='Routes' />
      <AppSidebarSubitem to='/cms/settings/themeSettings' alias='Theme Settings' />
      <AppSidebarSubitem to='/cms/settings/systemSettings' alias='System Settings' />
    </AppSidebarSubitems>
  </AppSidebar>
}

function TypeSidebarSubitems({ type, icon, alias }) {
  const { siteSettings: { useThemeConfig } } = useGlobalStore()
  const settings = useThemeConfig(`types.${type}`)

  if (type === 'page' || !settings) {
    return <AppSidebarItem to={`/cms/${type}`} icon={icon} alias={alias} />
  }

  return <AppSidebarSubitems icon={icon} alias={alias} to={`/cms/${type}`}>
    <AppSidebarSubitem to={`/cms/${type}/tags`} alias='Categories' />
    {type === 'sweep' && <>
      <AppSidebarSubitem to={`/cms/${type}/contests`} alias='Contests' />
      <AppSidebarSubitem to={`/cms/${type}/sca`} alias='SCA Promotions' />
    </>}
  </AppSidebarSubitems>
}

CMSSidebar.propTypes = propTypes
